import LienTab from "../../../../patient/details/lien/LienTab";

export default function LienDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <LienTab inWorkQ={inWorkQ} />
    </div>
}
